import request from "../helpers/request";

/**
 * Bloq siyahısı: GET /api/cms/blogs
 * @param {Object} params - search, category_id, category_slug, page
 * @returns {Promise<{ data: Array, links: Object, meta: Object }>}
 */
export const getBlogs = async (params = {}) => {
  const { search = "", category_id = "", category_slug = "", page = 1 } = params;
  const response = await request.get("/api/cms/blogs", {
    params: {
      search: search || undefined,
      category_id: category_id || undefined,
      category_slug: category_slug || undefined,
      page,
    },
  });
  return response.data;
};

/**
 * Bloq kateqoriyaları: GET /api/cms/blog-categories
 * @returns {Promise<{ data: Array<{ id, name, slug }> }>}
 */
export const getBlogCategories = async () => {
  const response = await request.get("/api/cms/blog-categories");
  return response.data;
};

/**
 * Bloq detalları URL-i (slug üstünlük verilir).
 * @param {{ slug?: string, id?: number|string }} blog
 */
export const getBlogDetailPath = (blog) => {
  const slug = blog?.slug;
  if (slug) return `/blog/${encodeURIComponent(slug)}`;
  if (blog?.id != null && blog.id !== "") return `/blog/${blog.id}`;
  return "/blog";
};

/**
 * Tək bloq: GET /api/cms/blog/:slug
 * @param {string} slug - Bloq slug
 * @returns {Promise<{ data: Object }>}
 */
export const getBlogBySlug = async (slug) => {
  const response = await request.get(`/api/cms/blog/${encodeURIComponent(slug)}`);
  return response.data;
};

/** @deprecated getBlogBySlug istifadə edin */
export const getBlogById = getBlogBySlug;

/**
 * Favorit bloqlar: GET /api/cms/blog-favorites
 * @returns {Promise<{ data: Array }>}
 */
export const getBlogFavorites = async () => {
  const response = await request.get("/api/cms/blog-favorites");
  return response.data;
};

/**
 * Bloq favoritə əlavə et / çıxar (toggle): POST /api/cms/blog/:id/favorite
 * Backend uğurda 200 qaytarmalıdır; 500 qaytarsa UI tərəfdə optimistik yeniləmə edilir.
 * @param {number|string} id - Bloq id
 * @returns {Promise}
 */
export const toggleBlogFavorite = async (id) => {
  const response = await request.post(`/api/cms/blog/${id}/favorite`, {});
  return response.data;
};
